import camelCase from 'lodash.camelcase';

const camelcaseKeysMiddleware = obj => {
  const newObject = Array.isArray(obj) ? [] : {};

  for (const prop in obj) {
    if (typeof obj[prop] === 'object' && obj[prop] !== null) {
      newObject[camelCase(prop)] = camelcaseKeysMiddleware(obj[prop]);
    } else {
      newObject[camelCase(prop)] = obj[prop];
    }
  }

  return newObject;
};

const defaultOptions = { global: true };

const checkCamelCaseKey = (action, options) => {
  if (action.error) return false;

  if (typeof action === 'object') {
    return (options.global || !!action.camelCase || !!action.meta.arg.camelCase) && action.camelCase !== false;
  }
};

const camelMiddleware = (options = defaultOptions) => store => next => action => {
  const shouldCamelCaseKeys = checkCamelCaseKey(action, options);

  if (typeof action === 'object' && shouldCamelCaseKeys) {
    const newAction = camelcaseKeysMiddleware(action);
    return next(newAction);
  }

  return next(action);
};

export default camelMiddleware;
